module.exports = __webpack_public_path__ + "img/Rectangle 9944.b585e196.svg";